import React, { Component } from 'react';
import moment from 'moment';
import { TextValidator } from 'react-material-ui-form-validator';
import { Grid, Button, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import ValidatedDatePicker from '../ValidatedDatePicker';

class EventDetails extends Component {
    constructor(props){
        super(props);
    }

    render(){
        const {
            classes,
            state,
            handleChange,
            handleDateChange,
            handleNext
        } = this.props;
        const { values, event_arr } = state;
        return (
            <>
            <div className={classes.fieldsContainer}>
                <Grid container spacing={2}>
                {event_arr.map((obj, i) => {
                    return (
                    <Grid item md={6} xs={12} key={i}>
                        <TextValidator
                        className={classes.field}
                        fullWidth
                        onChange={handleChange}
                        name={obj.name}
                        value={values[obj.name] ? values[obj.name] : ""}
                        label={
                            <label>
                            {obj.label}
                            {obj.required ? (
                                <span className={classes.requiredAsterisk}>
                                {' '}
                                *
                                </span>
                            ) : (
                                ''
                            )}
                            </label>
                        }
                        select={obj.select}
                        validators={[obj.validators]}
                        errorMessages={[obj.errorMessages]}
                        SelectProps={{ native: false }}
                        placeholder={obj.placeholder}
                        margin="dense"
                        InputLabelProps={{
                            shrink: true,
                            style: {
                            fontSize: 20,
                            top: '-5px',
                            fontWeight: 'bold',
                            },
                        }}
                        >
                        <MenuItem value="">{obj.placeholder}</MenuItem>
                        {state[obj['list']] != null &&
                            state[obj['list']] != undefined &&
                            state[obj['list']].length > 0 &&
                            state[obj['list']].map(function(elem, i) {
                            return (
                                <MenuItem value={elem._id} key={i}>
                                {elem[obj['type']]}
                                </MenuItem>
                            );
                            })}
                        </TextValidator>
                    </Grid>
                    );
                })}
                <Grid item md={6} xs={12}>
                    <ValidatedDatePicker
                    className={classes.field}
                    disablePast
                    minDate={moment()}
                    fullWidth
                    onChange={handleDateChange}
                    label={
                        <label>
                        Cut Off Date
                        <span className={classes.requiredAsterisk}> *</span>
                        </label>
                    }
                    name="event_date"
                    value={
                        values.event_date
                        ? values.event_date
                        : null
                    }
                    format="MM/DD/YYYY hh:mm A"
                    validators={['invalidDate', 'minimumDate', 'required']}
                    errorMessages={[
                        'Date is invalid',
                        `Date should not be before minimal date ${moment()
                        .add(1, 'days')
                        .format('MM/DD/YYYY')}`,
                        'This field is required',
                    ]}
                    invalidDateMessage={'Date is invalid'}
                    variant="inline"
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    minutesStep={5}
                    autoOk
                    InputLabelProps={{
                        shrink: true,
                        style: {
                        fontSize: 20,
                        top: '-5px',
                        fontWeight: 'bold',
                        },
                    }}
                    />
                </Grid>
                </Grid>
            </div>
            <Grid container className={classes.buttonContainer} spacing={4}>
                <Button
                className={classes.nextButton}
                onClick={() => handleNext('event_details')}
                variant="contained"
                color="primary"
                >
                Next
                </Button>
            </Grid>
             </>
        )
    }
}

export default withStyles(useStyles)(EventDetails)